/** @format */

import { createAction, props } from '@ngrx/store';

import { ProductSku } from '@shared/data-access/interfaces';
import { SelectedBundleSkus } from '@pdp/data-access/interfaces';

export const addToSetClicked = createAction(
	'[Bundle Product Page] Add To Set Clicked',
	props<{ sku: SelectedBundleSkus }>()
);

export const removeFromSetClicked = createAction(
	'[Bundle Product Page] Remove From Set Clicked',
	props<{ skuId: string }>()
);

export const skuResolved = createAction(
	'[Bundle Product Page] SKU Resolved',
	props<{ oldSku: ProductSku | null; newSku: ProductSku | null; quantity: string }>()
);

export const userSetInputQuantity = createAction(
	'[Bundle Product Page] User Set Input Quantity',
	props<{ sku: ProductSku; quantity: string }>()
);

export const addToCartTriggered = createAction('[Bundles Add To Cart] Add To Cart Triggered');
